<template>
  <div class="main">
    <div class="modal" v-show="showModal" style="display: block">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <img class="modal-image" src="../assets/images/we.png" alt="" />
        <center class="modal-text">
          <p class="modal-title">We Are Hiring Interns!</p>
          <p class="modal-description">Unlocking Your Path to Success!</p>
          <button class="btn text-blue-800"><a href="">Apply Now</a></button>
        </center>
      </div>
    </div>
    <header>
      <section id="hero" class="jumbotron text-center">
        <br />
        <br />
        <br />
        <br />
        <br />
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="display-4">Elevate Your IT Journey</h1>
              <p class="lead">
                Turn Your Unique Vision into Reality with Our Expertise and
                Proven Track Record of Success.
              </p>
              <a
                href=""
                class="btn btn-primary btn-lg"
                >Get Started &rarr;</a
              >
            </div>
          </div>
        </div>
      </section>
    </header>
  </div>

  <div class="intro6-section section lightPinkBg bg-white" id="services">
    <div class="container-fluid section-padding mt-3">
      <div class="row mt-md-n5 mb-lg-1 mb-md-5 mb-xs-5">
        <br />
        <div>
          <center>
            <h2 class="heading mt-1 mb-5">Our Internships</h2>
          </center>
        </div>

        <!-- icons -->
        <div class="container-fluid">
          <div class="container text-center">
            <div class="row d-flex justify-content-center">
              <a
                href=""
                style="text-decoration: none"
                class="iconq mx-2 col-lg-2 col-md-4 col-sm-6 col-12 shadow p-3 mb-5 bg-white"
              >
                <img
                  src="https://raw.githubusercontent.com/shahzaibkhalid/mern-app-generator/master/static/logo.png"
                  style="width: 100px"
                  alt=""
                />
                <h6 class="fs-6" style="font-weight: bold">
                  Full Stack Web Development
                </h6>
              </a>

              <a
                href=""
                style="text-decoration: none"
                class="iconq mx-2 col-lg-2 col-md-4 col-sm-6 col-12 shadow p-3 mb-5 bg-white"
              >
                <img
                  src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png"
                  style="width: 100px"
                  alt=""
                />
                <h6 class="fs-6" style="font-weight: bold">React JS</h6>
              </a>

              <a
                href=""
                style="text-decoration: none"
                class="iconq mx-2 col-lg-2 col-md-4 col-sm-6 col-12 shadow p-3 mb-5 bg-white"
              >
                <img
                  src="https://static.packt-cdn.com/products/9781838648121/graphics/assets/9a5e3a54-0f0e-42a2-ab09-3ab748173cfe.png"
                  style="width: 100px"
                  alt=""
                />
                <h6 class="fs-6" style="font-weight: bold">Web Development</h6>
              </a>

              <a
                href=""
                style="text-decoration: none"
                class="iconq mx-2 col-lg-2 col-md-4 col-sm-6 col-12 shadow p-3 mb-5 bg-white"
              >
                <img
                  src="https://static.vecteezy.com/system/resources/previews/019/899/948/original/java-free-download-free-png.png"
                  style="width: 100px"
                  alt=""
                />
                <h6 class="fs-6" style="font-weight: bold">Java</h6>
              </a>

              <a
                href=""
                style="text-decoration: none"
                class="iconq mx-2 col-lg-2 col-md-4 col-sm-6 col-12 shadow p-3 mb-5 bg-white"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/1869px-Python-logo-notext.svg.png"
                  style="width: 100px"
                  alt=""
                />
                <h6 class="fs-6" style="font-weight: bold">
                  Python Machine Learning
                </h6>
              </a>

              <a
                href=""
                style="text-decoration: none"
                class="iconq mx-2 col-lg-2 col-md-4 col-sm-6 col-12 shadow p-3 mb-5 bg-white"
              >
                <img
                  src="https://static.vecteezy.com/system/resources/thumbnails/020/975/579/small_2x/wordpress-logo-wordpress-icon-transparent-free-png.png"
                  style="width: 100px"
                  alt=""
                />
                <h6 class="fs-6" style="font-weight: bold">
                  Wordpress Development
                </h6>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="feature" style="margin-top: -70px">
        <div class="text-center col-lg col-sm">
          <div class="section-title">
            <h2 class="heading" style="margin-bottom: 50px">
              Features Of Our Internships
            </h2>
          </div>
        </div>

        <div class="container">
          <div class="row text-center">
            <div class="col-lg d-flex flex-column align-items-center">
              <img
                src="../assets/images/c.png"
                width="100px"
                height="100"
                alt=""
              />
              <h3>Verified Certificates</h3>
              <p class="fs-5">
                Get Verified Certificates to prove your hard work!
              </p>
            </div>

            <div class="col-lg d-flex flex-column align-items-center">
              <img
                src="../assets/images/experience.png"
                width="100px"
                height="100"
                alt=""
              />
              <h3>Hands-on experience</h3>
              <p class="fs-5">
                Gain practical experience by working on real-world projects.
              </p>
            </div>

            <div class="col-lg d-flex flex-column align-items-center">
              <img
                src="../assets/images/network.png"
                width="100px"
                height="100px"
                alt=""
              />
              <h3>Networking</h3>
              <p class="fs-5">
                Tap into our network and increase your chances of placements
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center col-lg" style="margin-top: -30px">
        <div class="section-title">
          <h2 class="heading mt-5 mb-3 title text-center">
            <span style="color: #f6ec32">Explore</span> Our Internships
          </h2>
        </div>
        <h4>
          At our organization, we offer diverse internship opportunities in Web
          Development, Machine Learning, Data Science, and more. Gain hands-on
          experience, contribute to real projects, and enhance your career
          prospects with us. Join our exciting journey!
        </h4>
      </div>

      <br />

      <!-- full stack web development -->
      <div class="container-fluid">
        <div class="container mt-5">
          <div class="row goku">
            <div class="col-lg-6">
              <div
                class="vl pl-2 px-2"
                style="border-left: 6px solid #515fe0; height: 30px"
              >
                <h3>Full stack web Development</h3>
              </div>
              <p class="uz mt-5">
                Full Stack Web Development is the art of building web
                applications from start to finish. It involves working on both
                the front-end and back-end components of a website, making it a
                comprehensive skill set for today's digital world.
              </p>

              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Front-End Development
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Back-End Development
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Database Management
              </div>
              <br />
              <a
                href=""
                class="btn btn-primary"
                >Apply Now</a
              >
            </div>
            <div class="col-lg-6 text-end">
              <br />
              <div class="d-none d-lg-block">
                <img src="../assets/images/fwb.jpg" width="300px" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- react -->
      <div class="container-fluid">
        <div class="container mt-5">
          <div class="row goku">
            <div class="col-lg-6">
              <div class="d-none d-lg-block">
                <img
                  src="https://www.rlogical.com/wp-content/uploads/2020/07/react-js-developer.png"
                  width="300"
                  alt=""
                />
              </div>
            </div>

            <div class="col-lg-6">
              <div
                class="vl pl-2 px-2"
                style="border-left: 6px solid #515fe0; height: 30px"
              >
                <h3>React JS</h3>
              </div>

              <p class="uz mt-5">
                React.js Development is the art of creating dynamic and
                interactive web applications using the React.js library, known
                for its efficiency and flexibility.
              </p>

              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Virtual DOM (Document Object Model)
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Component-Based Architecture
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Unidirectional Data Flow & JSX
              </div>
              <br />
              <a
                href=""
                class="btn btn-primary"
                >Apply Now</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- web development -->
      <div class="container-fluid">
        <div class="container mt-5">
          <div class="row goku">
            <div class="col-lg-6">
              <div
                class="vl pl-2 px-2"
                style="border-left: 6px solid #515fe0; height: 30px"
              >
                <h3>Web Development</h3>
              </div>

              <p class="uz mt-5">
                Web Development is the art of creating dynamic and interactive
                web applications, focusing on building engaging user interfaces
                and ensuring smooth functionality.
              </p>

              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Front-End Development
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Web Design and User Experience (UX)
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Client-Side Scripting
              </div>
              <br />
              <a
                href=""
                class="btn btn-primary"
                >Apply Now</a
              >
            </div>
            <div class="col-lg-6 text-end">
              <br />
              <div class="d-none d-lg-block">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/2210/2210153.png"
                  width="300px"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Wordpress Development -->
      <div class="container-fluid">
        <div class="container mt-5">
          <div class="row goku">
            <div class="col-lg-6">
              <br />
              <div class="d-none d-lg-block">
                <img
                  src="https://www.kgntechnologies.com/wp-content/uploads/2018/07/wordpress-1.png"
                  width="300px"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div
                class="vl pl-2 px-2"
                style="border-left: 6px solid #515fe0; height: 30px"
              >
                <h3>Wordpress Development</h3>
              </div>

              <p class="uz mt-5">
                WordPress Development is the art of creating dynamic and
                interactive websites, focusing on building robust and efficient
                web solutions using the WordPress content management system.
              </p>

              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Content Management System (CMS)
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Plugin Ecosystem
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Theming and Customization
              </div>
              <br />
              <a
                href=""
                class="btn btn-primary"
                >Apply Now</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Java -->
      <div class="container-fluid">
        <div class="container mt-5">
          <div class="row goku">
            <div class="col-lg-6">
              <div
                class="vl pl-2 px-2"
                style="border-left: 6px solid #515fe0; height: 30px"
              >
                <h3>Java</h3>
              </div>
              <p class="uz mt-5">
                Java Development is the art of creating dynamic and interactive
                applications, focusing on building robust and efficient software
                solutions using the Java programming language.
              </p>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Platform Independence
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Object-Oriented Programming (OOP)
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Strong Standard Library (Java API)
              </div>
              <br />
              <a
                href=""
                class="btn btn-primary"
                >Apply Now</a
              >
            </div>
            <div class="col-lg-6 text-end">
              <div class="d-none d-lg-block">
                <img
                  src="https://cdni.iconscout.com/illustration/premium/thumb/web-developer-working-on-website-8602638-6814339.png"
                  width="300px"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- python -->
      <div class="container-fluid">
        <div class="container mt-5">
          <div class="row goku">
            <div class="col-lg-6">
              <br />
              <div class="d-none d-lg-block">
                <img
                  src="https://cdni.iconscout.com/illustration/premium/thumb/male-python-developer-working-on-website-6081850-5054695.png"
                  width="300px"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div
                class="vl pl-2 px-2"
                style="border-left: 6px solid #515fe0; height: 30px"
              >
                <h3>Python Machine Learning</h3>
              </div>
              <p class="uz mt-5">
                Python Development is the art of creating dynamic and
                interactive applications, focusing on building robust and
                efficient software solutions using the Python programming
                language.
              </p>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                General-Purpose Language
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Interpreted and Dynamically Typed
              </div>
              <div>
                <img
                  src="https://w7.pngwing.com/pngs/271/535/png-transparent-check-mark-symbol-computer-icons-green-tick-mark-check-mark-black-and-white-symbol-thumbnail.png"
                  style="height: 20px"
                  alt=""
                />
                Extensive Standard Library
              </div>
              <br />
              <a
                href=""
                class="btn btn-primary"
                >Apply Now</a
              >
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    // Time delay in milliseconds (e.g., 1000ms = 1 second)
    const timeDelay = 2000;

    // Set a timeout to display the modal after the time delay
    setTimeout(() => {
      this.showModal = true;
    }, timeDelay);
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
/* Common styles for all screen sizes */
.modal {
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.modal-content {
  background-color: rgb(227, 247, 243);
  width: 50%;
  margin: 10% auto;
  padding: 20px;
  position: relative;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

.modal-image {
  width: 250px;
  max-height: 250px;
  display: inline-block;
  margin: 0 auto;
}

.modal-title {
  font-size: 23px;
  margin-bottom: 2px;
}

.modal-description {
  font-size: 14px;
  margin-bottom: 16px;
}

.btn {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  border-radius: 5px;
  cursor: pointer;
}

.btn a {
  color: inherit;
  text-decoration: none;
}

/* Responsive styles */
@media only screen and (max-width: 768px) {
  .modal-content {
    width: 80%;
    margin: 40% 30px auto;
  }
}

@media only screen and (max-width: 480px) {
  .modal-content {
    width: 80%;
    margin: 40% 30px auto;
  }
}

.star {
  margin: -2px;
}

.flex-container {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.hello {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.flex-container > div {
  width: 100px;
  height: 100px;
  margin: 10px;
  text-align: center;
  line-height: 75px;
  font-size: 30px;
  border-radius: 20%;
}

.div.iconq {
  width: 50px;
  height: 20px;
}

.iconq {
  border: 1px solid rgb(255, 255, 255);
  padding: 10px;
  border-radius: 40px;
  height: 180px;
  width: 200px;
  transition: box-shadow 0.3s ease-in-out;
}

.iconq:hover {
  box-shadow: 0 0.3rem 0.4rem #3ced77 !important;
}

/* Add this CSS within your HTML file or in your CSS file */
h6 {
  color: black;
  /* Set your desired link color */
}

@media (max-width: 575.98px) {
  .vl {
    border-left: none;
    border-top: 0px solid #9b51e0;
    height: auto;
  }

  h3 {
    font-size: 22px;
  }

  uz {
    font-size: 7px;
  }
}

p {
  font-size: 1rem;
}

h6 {
  font-size: 14px;
}

header {
  margin-top: -80px;
  background: url(https://camo.githubusercontent.com/5046cb083418fd1922b7f5990e594c3bb06f5d87e5516cd8839ae0aa48b3aec4/68747470733a2f2f696d616765732e73717561726573706163652d63646e2e636f6d2f636f6e74656e742f76312f3537363966633430316236333162616231616464623261622f313534313538303631313632342d5445363451474b524a4738535741495553374e532f6b6531375a77644742546f6464493870446d34386b506f73776c7a6a53564d4d2d53784f703743563539425a772d7a505067646e346a557756634a45315a7657515578776b6d794578676c4e714770304976544a5a616d574c49327a76595748384b332d735f3479737a63703272795449304871544f6161556f68724938504936465879386339505774426c7141566c555335697a7064634958445a71445976707252715a32395077306f2f636f64696e672d667265616b2e676966);
  background-size: auto;
  background-repeat: no-repeat;
  background-position: center;
  color: #01060d;
  display: flex;
  flex-direction: column;
}

#hero {
  margin-top: 480px;
}

#hero h1 {
  font-size: 40px;
  margin-top: 20px;
}

#hero p {
  font-size: 20px;
  font-weight: lighter;
  margin-bottom: 20px;
}

.btn {
  display: inline-block;
  padding: 10px 30px;
  background-color: #fff;
  color: black;
  font-weight: bold;
  background: #f6ec32;
  box-shadow: 0 8px 8px -4px lightblue;
  text-decoration: none;
  border-radius: 60px;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #10d42d;
}

.heading::before {
  top: 5.8rem;
  left: -2rem;
}

.heading::before,
.heading::after {
  content: "";
  position: absolute;
  height: 1.5rem;
  width: 1.5rem;
  border-top: 0.4rem solid #282c35;
  border-left: 0.4rem solid #282c35;
}

.heading::after {
  bottom: -0.5rem;
  right: -2rem;
  transform: rotate(180deg);
}

.heading {
  margin: 2rem;
  padding-top: 6rem;
  display: inline-block;
  font-size: 2.5rem;
  color: #100c08;
  position: relative;
  letter-spacing: 0.2rem;
}

.goku {
  display: flex;
  width: 90%;
  margin: 0 auto;
}
</style>
